import LegacyExperience from './EbGeneralInfo.legacy';
import { versioned } from '../../versioning/RenewalExperience';
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import PayScheduleFrequency from './PayScheduleFrequency';

function EbGeneralInfo({ caseId, onError = () => { } }) {

    const fetchUrl = `${config.API_URL}/EBGeneralInformations/ByCaseId/${caseId}`;

    const [generalInfo, setGeneralInfo] = useState({});
    const [originalData, setOriginalData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchGeneralInfo();
        fetchOriginalGeneralInfo();
    }, [caseId]);

    const fetchGeneralInfo = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setGeneralInfo(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
        } finally {
            setLoading(false);
        }
    };
    const fetchOriginalGeneralInfo = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/EBGeneralInformations/OriginalData/ByCaseId/${caseId}`);
            const originalData = response.data || [];
            setOriginalData(originalData);
        } catch (error) {
            if (error.response?.status !== 404) {
                setError('Error fetching original case files.');
            }
            onError(error);
        }
    };

    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;
    return (
        <Col lg={12} className="mb-3">
            <Card>
                <Card.Body>

                    <Row>
                        <Col lg={6}>
                            <Card.Title>General Information</Card.Title>
                        </Col>
                        <Col lg={6} className="text-end">
                            {/* You can add buttons or controls here if needed */}
                        </Col>
                    </Row>

                    <div className="table-responsive mb-3">
                        <table className="styled-table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th className="vertical-th"></th>
                                    <th><strong>Current Plan Year</strong></th>
                                    <th><strong>New Plan Year</strong></th>
                                </tr>
                            </thead>
                            <tbody>

                                {/* Row for Information Provider */}
                                <tr>
                                    <th>Contributions will be credited to participants accounts via <strong>{generalInfo?.informationProvider}. is this changing?</strong></th>
                                    <td>{originalData?.isInformationProviderChanged ? "Changed": "Not Changed"}</td>
                                    <td className={generalInfo?.isInformationProviderChanged !== originalData?.isInformationProviderChanged ? 'highlight-difference' : ''}>{generalInfo?.isInformationProviderChanged ? "Changed": "Not Changed"}</td>
                                </tr>

                                {/* Conditional rendering for "Deposit Vendor" */}
                                {generalInfo?.isInformationProviderChanged && (
                                    <>
                                        {/* Row for Payroll Vendor Name */}
                                        <tr>
                                            <th>Contributions will be credited to participants accounts via</th>
                                            <td>{originalData?.updatedInformationProvider}</td>
                                            <td className={generalInfo?.updatedInformationProvider !== originalData?.updatedInformationProvider ? 'highlight-difference' : ''}>{generalInfo?.updatedInformationProvider}</td>
                                        </tr>

                                        

                                        
                                    </>
                                )}

                            </tbody>
                        </table>

                    </div>
                    {generalInfo?.isInformationProviderChanged && (
                        <>
                    <Row>
                    <Col lg={6}>
                        <Card.Title>Pay Schedule Frequency</Card.Title>
                    </Col>
                    
                </Row>

                    <PayScheduleFrequency caseId={caseId}/>
                    </>
                )}
                </Card.Body>
            </Card>
        </Col>
    );

}

export default versioned(EbGeneralInfo, LegacyExperience);
